import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const inputCls = "w-full px-3 py-2.5 border border-[var(--line)] focus:border-[var(--accent)] outline-none text-sm";

export default function Account() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 6) return toast.error("New password must be at least 6 characters");
    if (form.new_password !== form.confirm) return toast.error("New passwords don't match");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password updated");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not update password");
    }
    setSaving(false);
  };

  return (
    <div className="mx-auto max-w-xl px-4 sm:px-6 py-12" data-testid="account-page">
      <h1 className="font-display font-extrabold text-3xl mb-1">Account</h1>
      <p className="text-[var(--ink-2)] text-sm mb-8">Signed in as <span className="font-semibold text-[var(--ink)]">{user?.email}</span></p>

      <div className="border border-[var(--line)] bg-white p-6">
        <h2 className="font-display font-bold text-lg mb-4 flex items-center gap-2"><KeyRound size={18} className="text-[var(--accent)]" /> Change password</h2>
        <form onSubmit={submit} className="space-y-3">
          <input type="password" autoComplete="current-password" value={form.current_password} onChange={(e) => set("current_password", e.target.value)} placeholder="Current password" className={inputCls} data-testid="current-password" required />
          <input type="password" autoComplete="new-password" value={form.new_password} onChange={(e) => set("new_password", e.target.value)} placeholder="New password (min 6 characters)" className={inputCls} data-testid="new-password" required />
          <input type="password" autoComplete="new-password" value={form.confirm} onChange={(e) => set("confirm", e.target.value)} placeholder="Confirm new password" className={inputCls} data-testid="confirm-password" required />
          <button type="submit" disabled={saving} data-testid="change-password-submit" className="bg-[var(--accent)] text-white font-semibold px-6 py-2.5 hover:bg-[var(--accent-hover)] disabled:opacity-60 text-sm">
            {saving ? "Updating…" : "Update password"}
          </button>
        </form>
      </div>
    </div>
  );
}
